import React from 'react';
import PropTypes from 'prop-types';
import Typography, { typographyShape } from '@nubank/nuds-web/components/Typography/Typography';

import { Row, Column } from './styles/Row';

function TableRow(props) {
  const { title, value, typographyProps } = props;

  return (
    <Row>
      <Column>
        <Typography {...typographyProps}>
          {title}
        </Typography>
      </Column>
      <Column textAlign="right">
        <Typography {...typographyProps}>
          {value}
        </Typography>
      </Column>
    </Row>
  );
}

TableRow.defaultProps = {
  typographyProps: {},
};

TableRow.propTypes = {
  title: PropTypes.string.isRequired,
  typographyProps: PropTypes.shape(typographyShape),
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
};

export default TableRow;
